import axios from 'axios'

import APIService from '../APIService/APIServiceImpl'
import CatalogServiceV1 from './CatalogServiceV1'

import { LiheContentResponseDTO, ServiceContentResponseItem, buildLiheContentResponseDTO } from "../../../../../requests-module"

import LocaleServiceImpl from '@/service/LocaleService/LocaleServiceImpl'

const localeService = new LocaleServiceImpl()

export default class CatalogServiceV1Impl
    extends APIService
    implements CatalogServiceV1 {
    constructor() {
        const serviceUrl = `https://api.travelski.com/catalog`
        super(serviceUrl)
    }

    async getLiheContent(
        lihe_id: string, prestation_ids: string[]
    ): Promise<LiheContentResponseDTO> {
        const locale = localeService.getLocale()

        const params = {
            lihe_id,
            season: this.getSeason(),
            prestation_ids: prestation_ids.join(","),
            locale,
        }
        const headers = {
            ...this.getDefaultHeaders(),
        }
        const url = `${this.getServiceUrl()}/lihe/info`
        const {data} = await axios.get(url, {
            params,
            headers,
        })
        return buildLiheContentResponseDTO(data)
    }

    async getServiceContent(
        service_ids: string[]
    ): Promise<ServiceContentResponseItem> {
        const locale = localeService.getLocale()

        const params = {
            service_ids: service_ids.join(","),
            locale,
        }
        const headers = {
            ...this.getDefaultHeaders(),
        }
        const url = `${this.getServiceUrl()}/service/info`
        const {data} = await axios.get(url, {
            params,
            headers,
        })
        return new ServiceContentResponseItem(data)
    }
}